import axios from 'axios';
import _ from 'lodash';
import { store } from '../../redux/store';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
const interpolateRegex = /\{\{(\S+?)\}\}/g;

export const fetchAPI = (
  settings,
  params = {},
  query = '',
  body = {},
  token = null
) => {
  const {
    // basePath = '',
    path = '',
    method = 'GET',
    get,
    fallback,
    adapter,
    transform,
    responseType,
    //auth = false,
    //...options
  } = settings;
  const paramsInterpolator = _.template(path, {
    interpolate: interpolateRegex,
  });
  const interpolatedPath = paramsInterpolator(params);

  const { from, to } = store.getState().year;

  switch (_.split(_.split(path, '/')[1], '?')[0]) {
    case 'user-yacht-members':
    case 'yachts':
    case 'bookings':
    case 'attendances':
    case 'logbooks':
    case 'operation-lists':
      query = {
        ...query,
        'filters[createdAt][$gte]': dayjs.utc(from).format('YYYY-MM-DD'),
        'filters[createdAt][$lte]': dayjs.utc(to).format('YYYY-MM-DD'),
      };
      break;
    default:
      break;
  }

  let headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (adapter) {
    body = adapter(body);
  }

  return axios({
    baseURL: process.env.REACT_APP_BASE_URL,
    method,
    url: interpolatedPath,
    params: query,
    data: body,
    headers,
    responseType,
  }).then((response) => {
    if (typeof response.data === 'undefined') {
      return fallback;
    }

    const data = [
      get &&
        function (data) {
          return _.get(data, get, fallback);
        },
      transform instanceof Function &&
        function (data) {
          return transform(data, response, settings);
        },
    ]
      .filter(Boolean)
      .reduce((data, fn) => fn(data), response.data);

    if (response.headers['content-disposition']) {
      return {
        data,
        headers: {
          'content-disposition': response.headers['content-disposition'],
        },
      };
    }

    return data;
  });
};
